<template lang="pug">
  .content
    .container.actions
      .actions__date
        //- h4.actions__date-title Weekly Class Calendars
        //- p.actions__date-range
          //- svg(xmlns='http://www.w3.org/2000/svg',x='0px', y='0px', width='16px', height='16px', viewBox='0 0 16 16').icon
          //-   circle(cx='11.7', cy='6.7', r='0.6')
          //-   path(d='M13.1,1.8h-0.7V1.2c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v0.6H8.5V1.2c0-0.3-0.3-0.6-0.6-0.6S7.4,0.9,7.4,1.2\
          //-   v0.6H4.8V1.2c0-0.3-0.3-0.6-0.6-0.6S3.6,0.9,3.6,1.2v0.6H2.9c-1.3,0-2.3,1-2.3,2.3v9c0,1.3,1,2.3,2.3,2.3h4.4c0.3,0,0.6-0.3,0.6-0.6\
          //-   s-0.3-0.6-0.6-0.6H2.9c-0.6,0-1.2-0.5-1.2-1.2v-9c0-0.6,0.5-1.2,1.2-1.2h0.7v0.6c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6V2.9\
          //-   h2.6v0.6c0,0.3,0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6V2.9h2.6v0.6c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6V2.9h0.7\
          //-   c0.6,0,1.2,0.5,1.2,1.2v3.3c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6V4.1C15.4,2.8,14.3,1.8,13.1,1.8z')
          //-   path(d='M11.9,8.4c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5S13.8,8.4,11.9,8.4z M11.9,14.2\
          //-   c-1.3,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S13.2,14.2,11.9,14.2z')
          //-   path(d='M12.7,11.3h-0.3v-0.6c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v1.2c0,0.3,0.3,0.6,0.6,0.6h0.8\
          //-   c0.3,0,0.6-0.3,0.6-0.6S13,11.3,12.7,11.3z')
          //-   circle(cx='9.2', cy='6.7', r='0.6')
          //-   circle(cx='6.7', cy='9.2', r='0.6')
          //-   circle(cx='4.2', cy='6.7', r='0.6')
          //-   circle(cx='4.2', cy='9.2', r='0.6')
          //-   circle(cx='4.2', cy='11.7', r='0.6')
          //-   circle(cx='6.7', cy='11.7', r='0.6')
          //-   circle(cx='6.7', cy='6.7', r='0.6')
          //- span {{ currentWeek }}
      .actions__classes
        span.actions__classes-title
          svg(xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="886 886 20 20").actions__classes-icon
            path(d="M905.419 887.039c.152.368.09.683-.188.943l-6.644 6.644v9.998c0 .377-.175.643-.525.795a.935.935 0 0 1-.337.067.8.8 0 0 1-.606-.256l-3.449-3.45a.825.825 0 0 1-.256-.606v-6.548l-6.643-6.644c-.278-.261-.341-.575-.188-.943.153-.351.418-.525.795-.525h17.248c.375 0 .64.174.793.525z")
          | Class Filter:
        v-select.actions__select(:options="$store.state.appointments" label="name" @input="getClassAboutAppointments" v-model="selectedAppointment" :clearable="false" :searchable="false")
      .sched
        ul.sched__times
          li.sched__time
          li.sched__time(v-for="(time, timeIndex) in defaultTime" :key="timeIndex" ref="timeRange")
            span {{ time }}
        .sched__content
          ul.sched__days
            li.sched__day(v-for="(day, dayIndex) in defaultWeek" :key="dayIndex" :class="['width-' + widthOfDays[dayIndex]]") {{ day }}
          .sched__container
            ul.sched__schedule-days
              li.sched__schedule-day(v-for="(day, dayIndex) in defaultDays" :key="dayIndex" :class="['width-' + widthOfDays[dayIndex]]")
                ul.sched__lessons
                  li.sched__lesson(v-for="(lesson, lessonIndex) in day" :key="lessonIndex")
            ul.sched__schedule-days-absolute
              li.sched__schedule-day-absolute(v-for="(newDay, dayNewIndex) in sortingLessons" :key="dayNewIndex" :class="['width-' + widthOfDays[dayNewIndex]]")
                ul.sched__lessons-absolute
                  li.sched__lesson-absolute(
                    v-for="(newLesson, lessonNewIndex) in newDay"
                    :key="lessonNewIndex"
                    :class="['h-' + Number(newLesson.duration / 10).toFixed(0), 'left-' + newLesson.left, 'z-' + lessonNewIndex]"
                    :style="'top:' + newLesson.top + 'px; border-top: 3px solid ' + newLesson.color"
                    v-if="(newLesson.typeId === $store.state.selectedAppointment) || ($store.state.selectedAppointment === null)"
                    )
                    .sched__lesson-absolute__link
                      p.sched__lesson-absolute__name {{ newLesson.name }}
                      p.sched__lesson-absolute__type {{ newLesson.category }}
                      p.sched__lesson-absolute__time {{ newLesson.start }} - {{ newLesson.end }}
      .sched-mobile
        ul.sched-mobile__days
          li.sched-mobile__day(v-for="(newDay, dayNewIndex) in sortingLessons" :key="dayNewIndex" :class="['width-' + widthOfDays[dayNewIndex]]" v-if="showingDays[dayNewIndex]")
            h4.sched-mobile__day-title {{ defaultWeek[dayNewIndex] }}
            ul.sched-mobile__lessons
              //li.sched-mobile__lesson(v-if="(newLesson.typeId !== $store.state.selectedAppointment) || ($store.state.selectedAppointment !== null)") Haven't lessons
              li.sched-mobile__lesson(
                v-for="(newLesson, lessonNewIndex) in newDay"
                :key="lessonNewIndex"
                :style="'border-left: 3px solid ' + newLesson.color"
                v-if="(newLesson.typeId === $store.state.selectedAppointment) || ($store.state.selectedAppointment === null)"
              )
                .sched-mobile__lesson-link
                  p.sched-mobile__lesson-name {{ newLesson.name }}
                  p.sched-mobile__lesson-type {{ newLesson.category }}
                  p.sched-mobile__lesson-time {{ newLesson.start }} - {{ newLesson.end }}
</template>

<script>
import moment from "moment";
export default {
  name: "Schedule",
  data() {
    return {
      canGenerate: false,
      classes: this.$store.state.classes,
      filteredClasses: [],
      weekDays: [],
      showingDays: [],
      defaultWeek: [],
      defaultTime: [],
      allTime: [],
      defaultDays: [],
      widthOfDays: [],
      newCLasses: [],
      lessonsToDisplay: [],
      currentWeek: "",
      intervals: [],
      selectedAppointment: {
        name: "All Classes",
        id: null
      }
    };
  },
  computed: {
    sortingLessons: function() {
      // console.log(this.newCLasses);
      this.newCLasses.map(classes => {
        classes.sort(function(a, b) {
          return moment(a.time).format("X") < moment(b.time).format("X")
            ? -1
            : moment(a.time).format("X") > moment(b.time).format("X")
            ? 1
            : 0;
        });
        if (
          this.selectedAppointment !== null ||
          this.selectedAppointment !== undefined
        ) {
          classes = classes.filter(item => {
            return item.typeId === this.selectedAppointment.id;
          });
        }
        // console.log(classes);
        return classes;
      });
      this.canGenerate = true;
      this.lessonsToDisplay = this.newCLasses;
      return this.newCLasses;
    },
    times() {
      return this.getActiveTimes();
    }
  },
  watch: {
    times() {
      this.generateTime();
      this.showRefs();
    },
    defaultTime(value) {
      this.defaultDays = [];
      const dayAmount = value.length;
      for (let i = 0; i < 7; i++) {
        const newDay = [];
        for (let j = 0; j < dayAmount + 5; j++) {
          newDay.push(j);
        }
        this.defaultDays.push(newDay);
      }
    }
  },
  mounted() {
    const today = moment()
      .weekday(1)
      .format("MMMM D, YYYY");
    const lastDay = moment()
      .weekday(7)
      .format("MMMM D, YYYY");
    this.currentWeek = today + " - " + lastDay;
    this.generateWeek();
    this.generateTime();
    this.generateDays();
    this.setDays();
    this.setPositions();
    this.showRefs();
    this.testingSorting();
  },
  methods: {
    getActiveTimes() {
      const times = [];
      let intervals = [];

      for (let day of Object.values(this.classes)) {
        for (let lesson of day) {
          if (
            lesson.typeId !== this.selectedAppointment.id &&
            this.selectedAppointment.id !== null
          ) {
            continue;
          }
          const startTime = moment(lesson.start, "hh:mm A").format("hh:mm A");
          const endTime = moment(lesson.end, "hh:mm A").format("hh:mm A");
          if (!times.includes(startTime)) {
            times.push(startTime);
          }
          if (!times.includes(endTime)) {
            times.push(endTime);
          }
          const existingInterval = intervals.find(item => {
            return item.start === startTime && item.end === endTime;
          });
          let newInterval = {
            start: startTime,
            end: endTime
          };
          if (!existingInterval) {
            intervals.push(newInterval);
          }
        }
      }
      this.intervals = intervals.sort((a, b) => {
        const aStart = moment(a.start, "hh:mm A").format("X");
        const bStart = moment(b.start, "hh:mm A").format("X");
        if (aStart !== bStart) {
          return aStart - bStart;
        } else {
          return moment(a.end, "hh:mm A") - moment(b.end, "hh:mm A");
        }
      });
      return times.sort((a, b) => {
        return (
          moment(a, "hh:mm A").format("X") - moment(b, "hh:mm A").format("X")
        );
      });
    },
    testingSorting() {
      let newTest = [];
      this.newCLasses.forEach(day => {
        let newDay = false;
        day.find(lesson => {
          if (
            lesson.typeId === this.$store.state.selectedAppointment ||
            this.$store.state.selectedAppointment === null
          ) {
            newDay = true;
          }
        });
        newTest.push(newDay);
      });
      this.showingDays = newTest;
    },
    generateWeek() {
      for (let i = 1; i < 8; i++) {
        this.defaultWeek.push(
          moment()
            .weekday(i, "d")
            .format("dddd")
        );
      }
      for (let i = 0; i < 7; i++) {
        this.widthOfDays.push(1);
      }
    },
    generateTime() {
      this.defaultTime = [];
      this.allTime = [];
      // console.log(this.times);

      const startTime = moment()
        .startOf("day")
        .add(+moment(9, "hh:mm A").format("h"), "hours");
      for (let i = 0; i < 156; i++) {
        for (let interval of this.intervals) {
          const timeItem = moment(startTime)
            .add(i * 5, "m")
            .format("hh:mm A");
          const timeItemTimestamp = moment(startTime)
            .add(i * 5, "m")
            .format("X");
          if (
            this.times.length > 1 &&
            (timeItemTimestamp >=
              moment(interval.start, "hh:mm A")
                .subtract(30, "m")
                .format("X") &&
              timeItemTimestamp <=
                moment(interval.end, "hh:mm A")
                  .add(30, "m")
                  .format("X")) &&
            !this.defaultTime.includes(timeItem)
          ) {
            this.defaultTime.push(timeItem);
          }
        }
      }
      for (let i = 0; i < 151; i++) {
        const timeItem = moment(startTime)
          .add(i * 5, "m")
          .format("hh:mm A");
        this.allTime.push(timeItem);
      }
      this.defaultTime = this.defaultTime.sort((a, b) => {
        return (
          moment(a, "hh:mm A").format("X") - moment(b, "hh:mm A").format("X")
        );
      });
      this.allTime = this.allTime.sort((a, b) => {
        return (
          moment(a, "hh:mm A").format("X") - moment(b, "hh:mm A").format("X")
        );
      });
    },
    generateDays() {
      // console.log(this.defaultTime.length);
      for (let i = 0; i < 7; i++) {
        const newDay = [];
        for (let j = 0; j < 156; j++) {
          newDay.push(j);
        }
        this.defaultDays.push(newDay);
      }
    },
    setDays() {
      let newClasses = [];
      this.defaultWeek.forEach(day => {
        newClasses.push(this.$store.state.classes[day]);
      });
      this.filteredClasses = newClasses;
    },
    setPositions() {
      let newClasses = [];
      const classes = this.classes;
      const currentWeek = this.defaultWeek;
      currentWeek.forEach(day => {
        if (classes[day]) {
          newClasses.push(classes[day]);
        } else {
          newClasses.push([]);
        }
      });
      this.newCLasses = newClasses;
    },
    showRefs() {
      this.$nextTick(() => {
        // console.log(this.defaultTime[0]);
        this.newCLasses.forEach(day => {
          let testLesson = {};

          day.forEach(lesson => {
            if (
              lesson.typeId === this.selectedAppointment.id ||
              this.selectedAppointment.id === null
            ) {
              if (lesson.start !== this.defaultTime[0]) {
                let timeStart = this.getAllMinutes(lesson.start);
                // if(timeStart > this.getAllMinutes(this.defaultTime[0])){
                //   timeStart = timeStart - this.getAllMinutes(this.defaultTime[0])
                //   lesson.top = timeStart * 3;
                // }
                // else{
                //   console.log(this.getAllMinutes(this.defaultTime[0]));
                //   timeStart = timeStart + 180 - (this.getAllMinutes(this.defaultTime[0])-this.getAllMinutes('09:00 AM'))
                //   lesson.top = timeStart * 3;
                // }
                // -----------------------
                // const suffix = lesson.start.split(/\s+/)[1]
                // if(timeStart < this.getAllMinutes('12:00') && suffix === 'PM') {
                //   console.log((this.allTime.length-this.defaultTime.length)*5);
                //   timeStart = Math.abs(timeStart - ((this.allTime.length - this.defaultTime.length)*5)) ;
                //   // lesson.top = timeStart * 3;
                //   lesson.top = 100000;
                // } else {
                //   timeStart = Math.abs(timeStart - this.getAllMinutes(this.defaultTime[0]))-((this.allTime.length - this.defaultTime.length)*5)
                //   lesson.top = timeStart * 3;
                // }
                const index = this.allTime.findIndex(item => {
                  return item === lesson.start;
                });
                let counter = 0;
                for (let i = 0; i <= index; i++) {
                  if (!this.defaultTime.includes(this.allTime[i])) {
                    counter++;
                  }
                }
                lesson.top =
                  Math.abs(
                    timeStart - this.getAllMinutes("09:00 AM") - counter * 5
                  ) * 3;
              } else {
                lesson.top = 0;
              }
              // console.log(lesson);
            }

            testLesson = lesson;
          });
        });
      });
    },
    getAllMinutes(timeString) {
      const formattedTime = moment(timeString, "hh:mm A").format("HH:mm");
      let timeStart = parseInt(formattedTime.split(":").join(""));

      timeStart = JSON.stringify(timeStart);

      if (timeStart.length === 3) {
        const getAllMinutes = +timeStart.slice(0, 1) * 60;
        timeStart = +getAllMinutes + +timeStart.slice(1, 3);
      } else if (timeStart.length === 4) {
        const getAllMinutes = +timeStart.slice(0, 2) * 60;
        timeStart = +getAllMinutes + +timeStart.slice(2, 4);
      }
      return timeStart;
    },
    setLS(date) {
      localStorage.setItem("selectedDate", JSON.stringify(date));
    },
    getClassAboutAppointments(value) {
      this.$store.commit("setSelectedAppointments", value.id);
      this.testingSorting();
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: 30px;
  &__date {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    @media (max-width: 991px) {
      width: 100%;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    @media (max-width: 991px) {
      flex-direction: column;
    }
    &-title {
      font-size: 18px;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 0;
      @media (max-width: 991px) {
        margin-bottom: 10px;
      }
    }
    &-range {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      margin-left: 40px;
      @media (max-width: 991px) {
        margin-left: 0;
        align-items: flex-start;
      }
      .icon {
        width: 16px;
        height: 16px;
        fill: #9fa1a5;
        min-width: 16px;
      }
      span {
        padding-left: 11px;
        line-height: 16px;
        font-size: 13px;
        color: #919398;
      }
    }
  }
  &__classes {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    @media (max-width: 991px) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
    }
    &-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #0477c6;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-right: 20px;
      @media (max-width: 991px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 15px;
      }
    }
    &-icon {
      display: block;
      width: 16px;
      height: 16px;
      margin-right: 10px;
      fill: currentColor;
    }
  }
  &__select {
    min-width: 300px;
    @media (max-width: 991px) {
      min-width: 100%;
      width: 100%;
      max-width: 100%;
    }
  }
}
.sched {
  overflow-x: hidden;
  width: 100%;
  margin-top: 30px;
  display: flex;
  align-items: stretch;
  @media (max-width: 767.98px) {
    display: none;
  }
  &__times {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100px;
    @media (max-width: 991px) {
      width: 75px;
    }
  }
  &__time {
    display: flex;
    justify-content: flex-end;
    height: 15px;
    font-size: 13px;
    color: #5b6069;
    text-align: right;
    padding-right: 25px;
    width: 100px;
    background-color: #fff;
    border-right: 1px solid #e0e6e8;
    &:first-child {
      height: 50px;
    }
    &:nth-child(6n + 2) {
      span {
        color: #5b6069;
      }
    }
    &:nth-child(3n) {
      /*color: transparent;*/
    }
    &:nth-child(3n + 4) {
      /*color: transparent;*/
    }
    &:nth-child(2n + 5) {
      /*color: transparent;*/
    }
    @media (max-width: 991px) {
      width: 75px;
      padding-right: 10px;
    }
    span {
      display: block;
      position: relative;
      top: -8px;
      color: transparent;
      z-index: 1;
    }
  }
  &__content {
    overflow-x: visible;
    background-color: #fff;
    width: calc(100% - 100px);
    display: flex;
    flex-direction: column;
    background-image: -o-repeating-linear-gradient(
      135deg,
      #fff 0,
      #fff 5px,
      #f7f7f7 5px,
      #f7f7f7 10px
    );
    background-image: repeating-linear-gradient(
      -45deg,
      #fff 0,
      #fff 5px,
      #f7f7f7 5px,
      #f7f7f7 10px
    );
    border-right: 1px solid #e6ebed;
    @media (max-width: 991px) {
      width: calc(100% - 75px);
    }
  }
  &__days {
    width: 100%;
    display: flex;
    align-items: center;
    height: 50px;
  }
  &__day {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #5b6069;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 50px;
    text-align: center;
    min-width: 100px;
    background-color: #fff;
    border-bottom: 1px solid #e0e6e8;
    border-right: 1px dashed #e6ebed;
    &:last-child {
      border-right: none;
    }
  }
  &__container {
    width: 100%;
    position: relative;
  }
  &__schedule-days {
    display: flex;
    &-absolute {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      flex: 1;
      display: flex;
    }
  }
  &__schedule-day {
    display: flex;
    flex-direction: column;
    &-absolute {
    }
    &:last-child {
      .sched__lesson {
        border-right: none;
      }
    }
  }
  &__lessons {
    display: flex;
    flex-direction: column;
    &-absolute {
      position: relative;
      width: 100%;
    }
    /*height: 50px;*/
  }
  &__lesson {
    height: 15px;
    line-height: 15px;
    text-align: center;
    border-right: 1px solid #e0e6e8;
    &:nth-child(3n) {
      border-bottom: 1px dashed #e6ebed;
      //border-bottom: 1px dashed blueviolet;
    }
    &:nth-child(6n) {
      border-bottom: 1px solid #e0e6e8;
      //border-bottom: 2px solid tomato;
    }
    &:last-child {
      border-bottom: none;
    }
    &-absolute {
      width: 100%;
      position: absolute;
      text-align: center;
      background-color: #ffffff;
      -webkit-transition: all 150ms ease;
      -o-transition: all 150ms ease;
      transition: all 150ms ease;
      -webkit-box-shadow: 0px 0px 0 1px #e6ebed;
      box-shadow: 0px 0px 0 1px #e6ebed;
      &:hover {
        -webkit-box-shadow: 0 5px 25px rgba(2, 8, 20, 0.15);
        box-shadow: 0 5px 25px rgba(2, 8, 20, 0.15);
        z-index: 100;
      }
      &__link {
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        width: 100%;
        height: 100%;
        text-align: center;
        text-decoration: none;
      }
      &__name {
        font-size: 13px;
        font-weight: 600;
        color: #020814;
        line-height: 1.3;
        margin-bottom: 8px;
      }
      &__type {
        font-size: 11px;
        font-weight: 600;
        color: #666;
        line-height: 1.4;
        margin-bottom: 5px;
      }
      &__time {
        font-size: 11px;
        color: #020814;
        line-height: 1.3;
      }
    }
  }
}
.sched-mobile {
  overflow-x: hidden;
  width: 100%;
  margin-top: 30px;
  display: flex;
  align-items: stretch;
  @media (min-width: 768px) {
    display: none;
  }
  &__days {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  &__day {
    width: 100%;
    margin-bottom: 30px;
    &-title {
      margin-bottom: 15px;
    }
  }
  &__lessons {
    display: flex;
    flex-direction: column;
  }
  &__lesson {
    margin-bottom: 7.5px;
  }
  &__lesson {
    width: 100%;
    text-align: center;
    background-color: #ffffff;
    -webkit-transition: all 150ms ease;
    -o-transition: all 150ms ease;
    transition: all 150ms ease;
    -webkit-box-shadow: 0px 0px 0 1px #e6ebed;
    box-shadow: 0px 0px 0 1px #e6ebed;
    &:hover {
      -webkit-box-shadow: 0 5px 25px rgba(2, 8, 20, 0.15);
      box-shadow: 0 5px 25px rgba(2, 8, 20, 0.15);
      z-index: 8;
    }
    &-link {
      padding: 15px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      width: 100%;
      height: 100%;
      text-align: center;
      text-decoration: none;
    }
    &-name {
      font-size: 13px;
      font-weight: 600;
      color: #020814;
      line-height: 1.3;
      margin-bottom: 8px;
    }
    &-type {
      font-size: 11px;
      font-weight: 600;
      color: #666;
      line-height: 1.4;
      margin-bottom: 5px;
    }
    &__time {
      font-size: 11px;
      color: #020814;
      line-height: 1.3;
    }
  }
}
@for $i from 0 through 50 {
  .h-#{$i} {
    height: calc(30px * #{$i});
  }
}
@for $i from 0 through 50 {
  .width-#{$i} {
    //min-width: calc(150px * #{$i});
    flex: 1;
    min-width: 100px;
    @media (max-width: 544px) {
      min-width: 100%;
    }
  }
}
@for $i from 0 through 50 {
  .left-#{$i} {
    left: calc(150px * #{$i});
  }
}
@for $i from 0 through 50 {
  .z-#{$i} {
    z-index: #{$i};
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Schedule.vue